.tableWrapper {
  display: inline-flex;
  justify-content: start;
  position: relative;
}

.table {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
  display: inline-flex;
  flex-direction: column;
  position: relative;
}

.rowGroup {
  display: flex;
  flex-direction: column;
}

.header {
  font-weight: bold;
}

.footer {
  font-style: italic;
}

.body {
  font-style: normal;
}

.row {
  position: relative;
}

.rowCells {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.rowCellsWithSpan {
  overflow: visible;
}

.rowResizing {
  cursor: row-resize;
}

.rowResizeHandle {
  background: transparent;
  border: 0;
  box-sizing: border-box;
  cursor: row-resize;
  height: 9px;
  left: 0;
  position: absolute;
  top: 100%;
  transform: translate(0, -5px);
  user-select: none;
  width: 100%;
  z-index: 2;
}

.rowResizeHandleDisabled {
  cursor: default;
  pointer-events: none;
}

.rowResizing .rowResizeHandle {
  cursor: row-resize;
}

.cell {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  box-sizing: border-box;
  display: block;
  flex: 0 0 auto;
  min-width: 0;
  overflow: visible;
  position: relative;
}

.cellContent {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  min-width: 0;
  overflow: hidden;
  width: 100%;
}

div.table.cellResizing,
div.table.cellResizing * {
  cursor: col-resize !important;
}

.colResizeOverlay {
  inset: 0;
  pointer-events: none;
  position: absolute;
  z-index: 6;
}

.colResizeHandle {
  background: transparent;
  border: 0;
  box-sizing: border-box;
  cursor: col-resize;
  bottom: 0;
  height: auto;
  left: 0;
  pointer-events: auto;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  touch-action: none;
  user-select: none;
  width: 9px;
  z-index: 7;
}

.colResizeHandleDisabled {
  cursor: default;
  pointer-events: none;
}

.cellLeaving {
  background-color: #f0f0f0;
  pointer-events: none;
  user-select: none;
}

.cellWithRowSpan {
  z-index: 1;
}

.rowLeaving .cell {
  background-color: #f0f0f0;
  pointer-events: none;
  user-select: none;
}

.cellSelected {
  background-color: rgba(77, 171, 247, 0.15);
}

.rowSelectHandle {
  background: transparent;
  border: 0;
  box-sizing: border-box;
  cursor: crosshair;
  height: 100%;
  left: 0;
  padding: 0;
  pointer-events: auto;
  position: absolute;
  top: 0;
  z-index: 3;
}

.rowSelectHandleSelected {
  background-color: rgba(77, 171, 247, 0.4);
}

.colSelectHandle {
  background: transparent;
  border: 0;
  box-sizing: border-box;
  cursor: crosshair;
  padding: 0;
  pointer-events: auto;
  position: absolute;
  top: 0;
  z-index: 5;
}

.colSelectHandleSelected {
  background-color: rgba(77, 171, 247, 0.4);
}

.zoneGrid {
  display: grid;
  gap: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  pointer-events: none;
}

.zoneGridCell {
  pointer-events: auto;
  transition: opacity 0.1s ease-out;
}
